import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { t } from 'c-3po';
import { toJS } from '../../../../helpers/ImmutableToJS';

import * as a from '../../../../../libs/actions';
import * as h from '../../../../../libs/helpers';
import * as u from '../../../../../libs/utils';
import * as agg from '../../../../../libs/aggregation';

import { RoleSwitcher } from '../../../../components/roleSwitcher';
import { Notice } from '../../../../ui/notice';
import { Spinner } from '../../../../ui/spinner';
import { ChatRow } from './chatRow';

// styles
import css from './list.sss';

// images
import EmptyChatSvg from './images/emptyChat.svg';

class ListView extends React.Component {

    static propTypes = {
        filteredChats: PropTypes.array,
        banChatListCollapsed: PropTypes.bool,
        openRoom: PropTypes.func,
    };

    checkLoadChatsCondition = () => {
        if (this.besidaListContainer) this.props.send(
            a.CHAT_CHECK_LIST_LOAD_CONDITION, this.besidaListContainer);
    }

    render() {
        const { filteredChats, userRole, isLoadingChats, userHasCompany, userHasC2CCompany, openRoom } = this.props;
        const isEmptyChats = (filteredChats.length === 0);

        return (
            <div
                className={css.root}
                data-qaid='chat_list'
                ref={(node) => { this.besidaListContainer = node; }}
                onScroll={this.checkLoadChatsCondition}
            >
                {(userHasCompany || userHasC2CCompany) ? (
                    <div className={css.roleSwitcher}>
                        <RoleSwitcher />
                    </div>
                ) : null}
                <div className={css.content}>
                    {filteredChats.length > 0 && (
                        h.sortChatsByRelevance(filteredChats).map((chat) => (
                            <ChatRow
                                chat={chat}
                                openRoom={openRoom}
                                userRole={userRole}
                                key={`${chat.room_ident}besidaChatList`}
                            />
                        ))
                    )}
                    {isEmptyChats && (
                        <Notice
                            image={EmptyChatSvg}
                            title={t`Нет чатов`}
                        >
                            {t`Быстро и удобно задавайте вопросы продавцам`}
                        </Notice>
                    )}
                    {isLoadingChats && <Spinner />}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const socketStore = u.getSocketStore(state);
    return {
        filteredChats: agg.getFilteredChats(
            socketStore.get('chats'),
            state.get('chatsStatus'),
            state.get('userRole')
        ),
        isLoadingChats: state.getIn(['isLoadingData', 'chats']),
        userHasCompany: state.get('userHasCompany'),
        userHasC2CCompany: state.get('userHasC2CCompany'),
        userRole: state.get('userRole'),
        locale: state.get('locale'),
    };
};

export const List = connect(mapStateToProps)(toJS(ListView));
